import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { getListEmployeeAction } from '@/redux/actions/employee';
import { getListEmployee, TGetListEmployeeResponse } from '@/services/api/employee';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* getListEmployeeSaga(action: ActionType<typeof getListEmployeeAction.request>): Generator {
  const { companyId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(getListEmployee, companyId);
    const getListEmployeeResponse: TGetListEmployeeResponse = response as TGetListEmployeeResponse;
    yield put(getListEmployeeAction.success(getListEmployeeResponse));
    successCallback?.(getListEmployeeResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getListEmployeeError');
    yield put(getListEmployeeAction.failure(err));
    failedCallback?.(err);
  }
}
